const LK_Filter =({color,width,height})=>{
    return(
        <svg id="Layer_1" fill={color} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #005c8e;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            <path class="cls-1" d="M0,0l45.49,60.66v56.33h9.75c8.97,0,16.25-7.27,16.25-16.25v-40.08L116.99,0H0ZM67.16,59.22v41.52c0,6.57-5.35,11.92-11.92,11.92h-5.42v-53.44l-4.33-5.78L8.67,4.33h99.65s-36.83,49.11-36.83,49.11l-4.33,5.78Z"/>
        </svg>
    );
};

export default LK_Filter;
